module.exports = __webpack_public_path__ + "img/horizontal_6_4_3016.9cb05f77.png";